import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOrderExcelResponse } from '~/types/order.types';

/**
 * [입고관리 > 입고요청관리] 입고 상품 엑셀 업로드 API
 */
const usePostOrderExcel = () => {
  const endPoint = '/api-oms/order/excel';

  const postOrderExcel = async (file: File) => {
    return axiosInstance
      .post<TypePostOrderExcelResponse>(
        endPoint,
        { file },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then(({ data }) => {
        return data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postOrderExcel };
};

export default usePostOrderExcel;

registerMockAPI<TypePostOrderExcelResponse>({
  method: 'post',
  endpoint: '/api-oms/order/excel',
  label: '출고주문/출고주문조회/주문 엑셀 일괄 등록',
  scenarios: [
    {
      name: '일부 실패 — 5건 중 2건',
      response: {
        totalCount: 5,
        successCount: 3,
        failCount: 2,
        failResults: [
          { clientOrderCode: 'CL-20260519-0004', failReason: '상품코드(G99999999)가 존재하지 않습니다.' },
          { clientOrderCode: 'CL-20260519-0005', failReason: '수령자 연락처 형식이 올바르지 않습니다.' },
        ],
      },
    },
    { name: '전건 성공 — 5건', response: { totalCount: 5, successCount: 5, failCount: 0, failResults: [] } },
  ],
});
